import { axiosMockAdapterInstance } from "apis";
import { getResponseData } from "mocksdata/index";

const CryptoCurrencies = [
  {
    name: "ZSD",
    slug: "zsd-bsc",
    network: "binance-smart-chain-testnet",
    address: "0xB9809E3955fA034bF3F9aE53e0Ab471E03D7c657",
    fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
    cmcId: 8772,
    decimal: 18,
    type: ["STABLE_COIN"],
    gasLimit: 70871,
    status: "INACTIVE",
    defaultStatus: "INACTIVE",
  },
  {
    name: "USDT",
    slug: "usdt-bsc",
    network: "binance-smart-chain-testnet",
    address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
    fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
    cmcId: 825,
    decimal: 18,
    type: ["STABLE_COIN", "POPULAR"],
    gasLimit: 70871,
    status: "ACTIVE",
    defaultStatus: "ACTIVE",
  },
  {
    name: "USDC",
    slug: "usdc-bsc",
    network: "binance-smart-chain-testnet",
    address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
    fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
    cmcId: 3408,
    decimal: 18,
    type: ["STABLE_COIN", "POPULAR"],
    gasLimit: 70871,
    status: "ACTIVE",
    defaultStatus: "ACTIVE",
  },
  {
    name: "BUSD",
    slug: "busd-bsc",
    network: "binance-smart-chain-testnet",
    address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
    fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
    cmcId: 4687,
    decimal: 18,
    type: ["STABLE_COIN", "POPULAR"],
    gasLimit: 70871,
    status: "ACTIVE",
    defaultStatus: "ACTIVE",
  },
  {
    name: "WETH",
    slug: "eth-bsc",
    network: "binance-smart-chain-testnet",
    address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
    fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
    cmcId: 2396,
    decimal: 18,
    type: ["POPULAR"],
    gasLimit: 70871,
    status: "ACTIVE",
    defaultStatus: "INACTIVE",
  },
  {
    name: "DAI",
    slug: "dai-bsc",
    network: "binance-smart-chain-testnet",
    address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
    fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
    cmcId: 4943,
    decimal: 18,
    type: ["OTHERS"],
    gasLimit: 70871,
    status: "ACTIVE",
    defaultStatus: "INACTIVE",
  },
  {
    name: "ADA",
    slug: "ada-bsc",
    network: "binance-smart-chain-testnet",
    address: "0x78e67d427480D18890C807B3be219A8777900EcB",
    fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
    cmcId: 2010,
    decimal: 18,
    type: ["OTHERS"],
    gasLimit: 70871,
    status: "ACTIVE",
    defaultStatus: "INACTIVE",
  },
  {
    name: "LUNA",
    slug: "luna-bsc",
    network: "binance-smart-chain-testnet",
    address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
    fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
    cmcId: 4172,
    decimal: 18,
    type: ["POPULAR"],
    gasLimit: 70871,
    status: "ACTIVE",
    defaultStatus: "INACTIVE",
  },
  {
    name: "SHIB",
    slug: "shib-bsc",
    network: "binance-smart-chain-testnet",
    address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
    fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
    cmcId: 5994,
    decimal: 18,
    type: ["POPULAR"],
    gasLimit: 70871,
    status: "ACTIVE",
    defaultStatus: "INACTIVE",
  },
  {
    name: "DOGE",
    slug: "doge-bsc",
    network: "binance-smart-chain-testnet",
    address: "0x6aed42281c7bE19fa5f7a6ee5d873B85A5306bFe",
    fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
    cmcId: 74,
    decimal: 18,
    type: ["POPULAR"],
    gasLimit: 70871,
    status: "ACTIVE",
    defaultStatus: "INACTIVE",
  },
];

export const onGetAllCurrencies = () => {
  axiosMockAdapterInstance.onGet("/settings/crypto-currencies").reply(() => {
    return [200, getResponseData(CryptoCurrencies)];
  });
};
